module.exports = __webpack_public_path__ + "static/media/profile-down-scanner-wv.f02f8ec2.png";